import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
export const REPORT_EXPORT = 'reporting.report.export';
export const REPORT_EXPORT_OPERATIONS = {
    [REPORT_EXPORT]: {
        id: REPORT_EXPORT,
        name: 'Export Report',
        implementationStatus: 'AVAILABLE',
        labelKey: 'operations.reporting.export.label',
        descriptionKey: 'operations.reporting.export.description',
        permission: 'organization:reports:export',
        permissionId: 'organization:reports:export',
        module: 'REPORTING',
        requiredModules: ['REPORTING'],
        requiresEntitledModule: true,
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH, ScopeType.CLIENT, ScopeType.PORTFOLIO],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        allowedPersonas: ['ORG_ADMIN', 'ORG_USER'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        requestedScope: {
            branchId: [{ source: 'body', field: 'branchId' }],
            clientAccountId: [{ source: 'body', field: 'clientAccountId' }],
            portfolioId: [{ source: 'body', field: 'portfolioAccountId' }],
        },
        forcesClientScope: true,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: REPORT_EXPORT,
        allowedActorTypes: [ActorType.USER, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['POST'],
        isReadOnly: true,
        isFinancial: true,
        supportDelegationEligible: true,
        delegationPolicy: 'EXPLICITLY_GRANTED',
        accessType: 'EXPORT',
    },
};
